<template>
  <div class="createPost-container">
    <el-form
      ref="postForm"
      :model="postForm"
      :rules="rules"
      label-width="100px"
      class="form-container"
      style="width: 500px"
    >
      <div class="createPost-main-container">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input
            ref="oldPassword"
            :key="oldPasswordType"
            v-model="postForm.oldPassword"
            :type="oldPasswordType"
          />
          <span class="show-pwd" @click="showPwd(2)">
            <svg-icon :icon-class="oldPasswordType === 'password' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input
            ref="password"
            :key="passwordType"
            v-model="postForm.password"
            :type="passwordType"
          />
          <span class="show-pwd" @click="showPwd(1)">
            <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPassword">
          <el-input
            ref="checkPassword"
            :key="checkPasswordType"
            v-model="postForm.checkPassword"
            :type="checkPasswordType"
          />
          <span class="show-pwd" @click="showPwd(3)">
            <svg-icon :icon-class="checkPasswordType === 'password' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>
        <el-form-item>
          <el-button @click="roleResetInfors">重 置</el-button>
          <el-button type="primary" @click="updateData()">确 定</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { updatepassword } from '@/api/user'
import { mapGetters } from 'vuex'

const defaultForm = {
  oldPassword: '',
  password: '',
  checkPassword: ''
}

export default {
  name: 'UserPassword',
  data() {
    const validateRequire = (rule, value, callback) => {
      if (value === '' || value === undefined || value === null) {
        this.$message({
          message: rule.field + '为必填项',
          type: 'error'
        })
        callback(new Error(rule.field + '为必填项'))
      } else if (value.length < 6 || value.length > 15) {
        this.$message({
          message: rule.field + '长度限定在6到15',
          type: 'error'
        })
        callback(new Error(rule.field + '长度限定在6到15'))
      } else {
        if (this.postForm.checkPassword !== '') {
          this.$refs.postForm.validateField('CheckPassword')
        }
        callback()
      }
    }
    const validateCheckPass = (rule, value, callback) => {
      if (value === '' || value === undefined || value === null) {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.postForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      postForm: Object.assign({}, defaultForm),
      loading: false,
      passwordType: 'password',
      oldPasswordType: 'password',
      checkPasswordType: 'password',
      rules: {
        oldPassword: [{ validator: validateRequire, trigger: 'blur' }],
        password: [{ validator: validateRequire, trigger: 'blur' }],
        checkPassword: [{ validator: validateCheckPass, trigger: 'blur' }]
      }
    }
  },
  methods: {
    updateData() {
      this.loading = true
      this.$refs['postForm'].validate(valid => {
        if (valid) {
          const tempData = Object.assign({}, this.postForm)
          updatepassword(tempData.oldPassword, tempData.password).then(() => {
            this.loading = false
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    roleResetInfors() {
      this.$refs.postForm.resetFields()
    },
    showPwd(val) {
      if (val === 1) {
        if (this.passwordType === 'password') {
          this.passwordType = ''
        } else {
          this.passwordType = 'password'
        }
        this.$nextTick(() => {
          this.$refs.password.focus()
        })
      } else if (val === 2) {
        if (this.oldPasswordType === 'password') {
          this.oldPasswordType = ''
        } else {
          this.oldPasswordType = 'password'
        }
        this.$nextTick(() => {
          this.$refs.oldPassword.focus()
        })
      } else if (val === 3) {
        if (this.checkPasswordType === 'password') {
          this.checkPasswordType = ''
        } else {
          this.checkPasswordType = 'password'
        }
        this.$nextTick(() => {
          this.$refs.checkPassword.focus()
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';

.createPost-container {
  position: relative;

  .createPost-main-container {
    padding: 40px 45px 20px 50px;

    .show-pwd {
      position: absolute;
      right: 10px;
      top: 2px;
      font-size: 16px;
      color: #889aa4;
      cursor: pointer;
      user-select: none;
    }
  }
}
</style>
